var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-placeholder",class:{'is-loading' : _vm.isLoading }},_vm._l((_vm.numberOfItems),function(i){return _c('span',{key:'item_' + i,staticClass:"placeholder has-background-grey-light",class:{'has-spacing': _vm.hasSpacing},style:(`width: ${_vm.getRandomInt(24,200)}px`)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }